import { useLocation, useRouteMatch } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes';

export const useRoutes = () => {
  const location = useLocation();
  const isCollections = CONFIG.AUCTION_TYPE === 'collection';
  const getUrl = () => {
    switch (true) {
      case new RegExp(`${ROUTE_PATHS.MY_LOTS}`).test(location.pathname):
        return ROUTE_PATHS.MY_LOTS_LISTING;
      case new RegExp(`${ROUTE_PATHS.MY_BIDS}`).test(location.pathname):
        return ROUTE_PATHS.MY_BIDS_LISTING;
      case new RegExp(`${ROUTE_PATHS.PREVIEW_AUCTIONS}`).test(location.pathname):
        return ROUTE_PATHS.PREVIEW_AUCTIONS_LISTING;
      case new RegExp(`${ROUTE_PATHS.CLOSE_AUCTIONS}`).test(location.pathname):
        return ROUTE_PATHS.CLOSE_LISTING;
      default:
        return ROUTE_PATHS.ACTIVE_AUCTIONS_LISTING;
    }
  };
  const getAuctionUrl = () => {
    switch (true) {
      case new RegExp(`${ROUTE_PATHS.MY_LOTS}`).test(location.pathname):
        return ROUTE_PATHS.MY_LOTS_AUCTION;
      case new RegExp(`${ROUTE_PATHS.MY_BIDS}`).test(location.pathname):
        return ROUTE_PATHS.MY_BIDS_AUCTION;
      case new RegExp(`${ROUTE_PATHS.PREVIEW_AUCTIONS}`).test(location.pathname):
        return ROUTE_PATHS.PREVIEW_AUCTIONS_AUCTION;
      default:
        return ROUTE_PATHS.MY_AUCTION;
    }
  };

  const getRouteName = () => {
    switch (true) {
      case RegExp(`${ROUTE_PATHS.PREVIEW_AUCTIONS}`).test(location.pathname):
        return isCollections ? 'All Items' : 'Preview Auctions';
      case RegExp(`${ROUTE_PATHS.ACTIVE_AUCTIONS}`).test(location.pathname):
        return isCollections ? 'All Items' : 'Active Auctions';
      case RegExp(`${ROUTE_PATHS.CLOSE_AUCTIONS}`).test(location.pathname):
        return isCollections ? 'Closed Catalog' : 'Closed Auctions';
      case RegExp(`${ROUTE_PATHS.MY_LOTS}`).test(location.pathname):
        return 'My Lots For Sale';
      case RegExp(`${ROUTE_PATHS.MY_BIDS}`).test(location.pathname):
        return isCollections ? 'My Offers' : 'My Bids';
      default:
        return 'My Auctions';
    }
  };
  const url = getUrl();
  const name = getRouteName();
  const auctionUrl = getAuctionUrl();
  const isHomeRoute = useRouteMatch(ROUTE_PATHS.HOME);
  const isCatalog = CONFIG.AUCTION_TYPE === 'collection';
  const howItWorksRoute = useRouteMatch(ROUTE_PATHS.HOW_IT_WORKS);
  const termsAndConditions = useRouteMatch(ROUTE_PATHS.TERMS_AND_CONDITIONS);
  const faq = useRouteMatch(ROUTE_PATHS.FAQ);
  const isFaqTab = howItWorksRoute || termsAndConditions || faq;
  const isMyLots = useRouteMatch(ROUTE_PATHS.MY_LOTS);
  const isMyBids = useRouteMatch(ROUTE_PATHS.MY_BIDS);
  const isActiveCloseAuctions = useRouteMatch(ROUTE_PATHS.CLOSE_AUCTIONS);
  const isMyAuctions = useRouteMatch(ROUTE_PATHS.MY_AUCTIONS);
  const isApproveBidders = useRouteMatch(ROUTE_PATHS.ACCOUNTS);
  const isAdminTab = !!isActiveCloseAuctions || !!isMyAuctions || !!isApproveBidders;
  const isMyAccountTab = !!isMyLots || !!isMyBids;

  return {
    url,
    auctionUrl,
    match: useRouteMatch(url),
    name,
    isHomeRoute,
    isCatalog,
    isFaqTab,
    isAdminTab,
    isMyAccountTab
  };
};
